namespace GeniuzPOS.Purchase {
    export interface PoShipAddressRow {
        Id?: number;
        ShipId?: string;
        ShopId?: string;
        WhsId?: string;
        ShipName?: string;
        ShipLineAddress1?: string;
        ShipLineAddress2?: string;
        ShipLineAddress3?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        LookupName?: string;
    }

    export namespace PoShipAddressRow {
        export const idProperty = 'ShipId';
        export const nameProperty = 'LookupName';
        export const localTextPrefix = 'Purchase.PoShipAddress';
        export const lookupKey = 'Purchase.PoShipAddress';

        export function getLookup(): Q.Lookup<PoShipAddressRow> {
            return Q.getLookup<PoShipAddressRow>('Purchase.PoShipAddress');
        }
        export const deletePermission = '5Purchase:ข้อมูลอ้างอิงระบบซื้อ:Modify';
        export const insertPermission = '5Purchase:ข้อมูลอ้างอิงระบบซื้อ:Modify';
        export const readPermission = '5Purchase:ข้อมูลอ้างอิงระบบซื้อ:View';
        export const updatePermission = '5Purchase:ข้อมูลอ้างอิงระบบซื้อ:Modify';

        export declare const enum Fields {
            Id = "Id",
            ShipId = "ShipId",
            ShopId = "ShopId",
            WhsId = "WhsId",
            ShipName = "ShipName",
            ShipLineAddress1 = "ShipLineAddress1",
            ShipLineAddress2 = "ShipLineAddress2",
            ShipLineAddress3 = "ShipLineAddress3",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            LookupName = "LookupName"
        }
    }
}
